import { Box, Drawer, IconButton, Typography } from "@mui/material"
import { DoubleArrow } from "@mui/icons-material"
import theme from "src/theme/light"

interface InformationDrawerProps{
  isOpen: boolean
  close: () => void
}

interface TitleProps {
  text: string
}

interface Item {
  title?: string;
  items: string[]
}

const WHATSAPP_PHONE = "(48) 2106-0006"
const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=55${WHATSAPP_PHONE.replace(/\D/g, '')}`


const items: {[index: string]: Item[]} = {
  'Tensão da rede': [{
    title: '127/220V',
    items: ['Fase-neutro = 127V.', 'Fase-fase = 220V.', 'Fase-fase-neutro = 220V.']
  },
  {
    title: '220/380V',
    items: ['Fase-neutro = 220V.', 'Fase-fase = 380V.', 'Fase-fase-neutro = 380V.']
  }],
  'Número de fases': [{
    title: 'Monofásico',
    items: ["No local de instalação chegam <strong>uma</strong> Fase e <strong>um</strong> Neutro da rede da concessionária/cooperativa."]
  }, {
    title: 'Bifásico',
    items: ['No local de instalação chegam <strong>duas</strong> Fases e <strong>um</strong> Neutro da rede da concessionária/cooperativa.']
  },{
    title: 'Trifásico',
    items: ['No local de instalação chegam <strong>três</strong> Fases e <strong>um</strong> Neutro da rede da concessionária/cooperativa.']
  }],
  'Fator de perdas': [{
    items: ['Corresponde ao fator relacionado às perdas intrínsecas do sistema fotovoltaico, como local de instalação com alta poluição, sombreamento, temperatura da região de instalação e perdas no cabeamento CC e CA.']
  }],
  'Dúvidas': [{
    items: [`Em caso de dúvidas,  consulte a conta de luz do cliente ou nos ligue pelo telefone e whatsapp: <a target="_blank" href=${WHATSAPP_URL}>${WHATSAPP_PHONE}</a>`]
  }]
}


const Title = ({ text }: TitleProps) => {
  return (
    <Box my={4}>
      <Typography variant="h5" color="primary"><strong>{text}</strong></Typography>
    </Box>
  )
}

function InformationDrawer({ isOpen, close }: InformationDrawerProps){
  return (
    <Drawer anchor="right" open={isOpen} onClose={close}>
      <Box width="40px" height="40px" margin="18px 0 0 18px">
        <IconButton onClick={close} aria-label="Fechar drawer" size="large">
          <DoubleArrow />
        </IconButton>
      </Box>
      <Box width="400px" px={4} mb={4}>
        {Object.keys(items).map((title) => {
          const item = items[title]

          return (
            <>
              <Title text={title} />
              {item.map(register => {
                return (
                  <Box mt={4}>
                    {register.title && <Typography variant='body1' color="textSecondary"><strong>{register.title}</strong></Typography>}
                    {register.items.map(item => {
                      return <div style={{ color: theme.palette.text.secondary, fontSize: 16  }} dangerouslySetInnerHTML={{__html: item}}></div>
                    })}
                  </Box>
                )
              })}
            </>
          )
        })}
      </Box>
    </Drawer>
  );
}

export { InformationDrawer }